var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showScrollIndicator)?_c('div',{staticClass:"scroll-indicator",on:{"click":_vm.scrollToTop}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }